import { render, staticRenderFns } from "./ArrowPageRightIcon.vue?vue&type=template&id=f2b13918"
import script from "./ArrowPageRightIcon.vue?vue&type=script&lang=ts"
export * from "./ArrowPageRightIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports